import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { lazyExecute3SPrimeCall } from 'owa-substrate-people-suggestions';
import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "RecipientCache" */ './lazyIndex')
);

let lazyInitializeCache = new LazyAction(lazyModule, m => m.initializeCache);

export { EmailAddressWrapper };

runAfterInitialRender(() => {
    lazyInitializeCache.importAndExecute();

    if (shouldUse3SPeopleSuggestions()) {
        lazyExecute3SPrimeCall.importAndExecute(true /*initializeBindStatus*/);
    }
});
